import { useEffect, useState } from "react";
import "./header.css"
import { FaHeadset } from "react-icons/fa6";
import { FaLock } from "react-icons/fa6";
import { FaTruck } from "react-icons/fa6";

function Header() {
    const [image, setImage] = useState("../../images/header3.jpg")
    const [mobileImage , setMobileImage] = useState("../../images/header1.jpg")
    const [animation, setAnimation] = useState(false)
    let index = 0

    useEffect(() => {
        let desktopImages = ["../../images/header3.jpg", "../../images/header4.jpg"]
        let mobileImages = ["../../images/header1.jpg", "../../images/header2.jpg"]
        
        setAnimation(true)
        const timer = setInterval(() => {
            index++;
            if (index > desktopImages.length - 1) {
                index = 0
            }
            setImage(desktopImages[index])
            setMobileImage(mobileImages[index])
        }, 5000);
        setTimeout(() => {
            setAnimation(false)
        }, 500);

        return () => clearInterval(timer)
    }, [image])
    return (
        <div className="header">
            <div className="header-container">
                <div className={animation ? "banner animation" : "banner"}>
                    <img className="desktop-image" src={image} alt="" />
                    <img className="mobile-image" src={mobileImage} alt="" />
                </div>
                <div className="owl-stage">
                    <div className="owl-stage-container">
                        <div className="owl-item">
                            <FaTruck size={35} />
                            <div>
                                <span>حمل و نقل سریع و رایگان</span>
                                <span className="span2">ارسال رایگان در خرید بالای 800 هزار تومن</span>
                            </div>
                        </div>
                        <div className="owl-item">
                            <FaHeadset size={35} />
                            <div>
                                <span>پشتیبان سریع</span>
                                <span className="span2">دسترسی سریع به پشتیبانی</span>
                            </div>
                        </div>
                        <div className="owl-item">
                            <FaLock size={35} />
                            <div>
                                <span>پرداخت امن</span>
                                <span className="span2">امنیت پرداخت</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header;


// https://www.tulikamode.com/Content/Media/Slider/208_m.jpg
// 	https://www.tulikamode.com/Content/Media/Slider/213_m.jpg